import { render, staticRenderFns } from "./BaseTLModalDialogTreeView.vue?vue&type=template&id=627bb712&"
import script from "./BaseTLModalDialogTreeView.vue?vue&type=script&lang=ts&"
export * from "./BaseTLModalDialogTreeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports